<template>
  <div>
    <Header />
    <router-view />

    <Foot />
  </div>
</template>

<script>
import Header from './libs/Header';
import Foot from './libs/Foot';
export default {
  name: 'Main',
  data() {
    return { path: '/', daoTime: null };
  },
  components: {
    Header,
    Foot,
  },
  created() {
    let that = this;
    // if (sessionStorage.getItem('token')) {
    //   that.openDaoTime();
    //   that.getUserInfo();
    // }
    // that.getApp();
  },
  updated() {},
  mounted() {},
  methods: {
    close() {
      $('.app_download_area').hide();
    },
    getAgentLoginUrl() {
      let that = this;

      that.goNav(`/gamePage?dailiD=1`);
    },
  
    closeDaoTime() {
      this.$parent.closeDaoTime();

    },
    openDaoTime() {
      let that = this;
      that.$parent.openDaoTime();
    },
      clearUser() {
      let that = this;
      that.$parent.clearUser();
    },

    // 父级公共方法
    getUserInfos() {
      let that = this;
      that.$parent.showLoading();
      that.$parent.getUserInfo();
      setTimeout(function () {
        that.$parent.hideLoading();
      }, 500);
    },
    getUserInfo() {
      let that = this;
      that.$parent.getUserInfo();
    },
    getApp() {
      let that = this;
      this.$parent.getApp();
    },
    openGamePage(name, type, code) {
      let that = this;
      this.$parent.openGamePage(name, type, code);
    },

    goNav(url) {
      let that = this;
      if (url == '/hongbao') {
        if (!that.$store.state.token) {
          this.$router.push({ path: '/login' });
          return;
        }
        if (that.$store.state.appInfo.redpacket_switch == 0) {
          that.showTost(0, '红包已关闭');
          return;
        }
      }
      this.$parent.goNav(url);
    },
    openKefu() {
      let that = this;
      that.$parent.openKefu();
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    showTost(type, title) {
      let that = this;
      that.$parent.showTost(type, title);
    },
  },

  watch: {
    //监听路由地址的改变
    $route: {
      immediate: true,
      handler() {
        let that = this;
        that.path = this.$route.path;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Main.vue